import React, { useEffect, useState } from 'react';
import './SuccessModal.css';

interface SuccessModalProps {
  isOpen: boolean;
  message: string;
  subMessage?: string;
  countdown?: number;
  onClose?: () => void;
}

const SuccessModal: React.FC<SuccessModalProps> = ({
  isOpen,
  message,
  subMessage,
  countdown = 5,
  onClose
}) => {
  const [timer, setTimer] = useState(countdown);

  useEffect(() => {
    let interval: NodeJS.Timeout;

    if (isOpen && timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }

    if (timer === 0 && onClose) {
      onClose();
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [isOpen, timer, onClose]);

  if (!isOpen) return null;

  return (
    <div className="success-modal-overlay font-tomorrow">
      <div className="success-modal">
        <button className="close-button" onClick={onClose}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41L17.59 5Z" fill="#555555" />
          </svg>
        </button>
        <div className="success-icon">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"
              fill="#14172B"
            />
          </svg>
        </div>
        <h2>{message}</h2>
        {subMessage && <p>{subMessage}</p>}
        {/* {countdown > 0 && (
          <p className="countdown">
            Hệ thống sẽ trở về trang chủ sau {timer}s
          </p>
        )} */}
      </div>
    </div>
  );
};

export default SuccessModal; 